import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { saveAs } from 'file-saver'

import { Button } from '@material-ui/core'

import { TableRow, TableCell } from 'components/Table'
import { MenuButton } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'

import * as service from 'service'

const ReportVersionRow = ({
  reportVersion,
  setReportVersion,
  setOpenDestroy,
}) => {
  const [loading, setLoading] = useState(false)
  const snackbar = useSnackbar()

  const [url, setUrl] = useState('')

  const getUrl = async () => {
    if (!!url) return url

    const response = await service.dponet.reportVersions.get({
      reportVersionId: reportVersion?.id,
    })

    const reportUrl = response?.data?.reportVersion?.url
    setUrl(reportUrl)
    return reportUrl
  }

  // Busca o binário via fetch em vez de navegar direto pra url do S3 — abrir a url crua
  // (window.open) faz o antivírus de alguns usuários flagar o link.
  const handleView = async () => {
    setLoading(true)

    try {
      const reportUrl = await getUrl()
      const file = await helpers.file.fromUrl(reportUrl, reportVersion?.name)
      const objectUrl = URL.createObjectURL(file)
      window.open(objectUrl, '_blank')
    } catch {
      snackbar.open({
        variant: 'error',
        message: 'Ocorreu um erro ao carregar o relatório',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleDownload = async () => {
    setLoading(true)

    try {
      const reportUrl = await getUrl()
      const response = await fetch(reportUrl)
      const blob = await response.blob()

      saveAs(blob, reportVersion?.name)
    } catch {
      snackbar.open({
        variant: 'error',
        message: 'Ocorreu um erro ao baixar o relatório',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleDestroy = () => {
    setReportVersion(reportVersion)
    setOpenDestroy(true)
  }

  return (
    <TableRow>
      <TableCell>{reportVersion?.id}</TableCell>
      <TableCell align="center">{reportVersion?.authorName}</TableCell>
      <TableCell align="center">{reportVersion?.version}</TableCell>
      <TableCell align="center">{reportVersion?.fileType}</TableCell>
      <TableCell align="center">
        {helpers.formatters.dateLocaleFormat(
          reportVersion?.createdAt,
          'DD/MM/yy',
        )}
      </TableCell>
      <TableCell align="right">
        <MenuButton iconButtonSize="small">
          {reportVersion?.fileType === 'pdf' && (
            <Button disabled={loading} onClick={handleView}>
              Visualizar
            </Button>
          )}
          <Button disabled={loading} onClick={handleDownload}>
            Baixar
          </Button>
          <Button disabled={loading} onClick={handleDestroy}>
            Excluir
          </Button>
        </MenuButton>
      </TableCell>
    </TableRow>
  )
}

ReportVersionRow.propTypes = {
  reportVersion: PropTypes.object,
  setReportVersion: PropTypes.func,
  setOpenDestroy: PropTypes.func,
  isRopa: PropTypes.bool,
}

export default ReportVersionRow
